import React, { useContext, useEffect, useState } from "react";
import { Alert, Dialog, Table } from "../../../layout";
import { Button } from "../../../controls";
import CashAddAndRemove from "./CashAddAndRemove";
import { Chip } from "@mui/material";
import { formatDate, lsGet, useFormatPrice } from "../../../hooks/Method";
import { AppContext } from "../../../App";
import { action, API, controller } from "../../../api/api";
import { DropLi } from "../../../hooks";

const CashMgmts = () => {
  const formatPrice = useFormatPrice();
  const activeReg = lsGet("activeReg");
  const { TxnTypes } = DropLi();
  const { authUser, setLoader } = useContext(AppContext);
  const [showForm, setShowForm] = useState(false);
  const [txns, setTxns] = useState([]);
  const [cashInForm, setCashInForm] = useState(false);
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  useEffect(() => {
    if (activeReg && authUser) {
      setLoader(true);
      API(controller.CashMgmt + action.GetAllByReg).getById(
        activeReg.id,
        (res) => {
          res.status === 200 && setTxns([...res.result]);
          setLoader(false);
        }
      );
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authUser]);

  const handleAdd = (isCashInForm = true) => {
    setCashInForm(isCashInForm);
    setShowForm(true);
  };

  const HeaderComp = () => (
    <div className="d-flex g-10">
      <Button onClick={() => handleAdd(true)}>Add Cash</Button>
      <Button onClick={() => handleAdd(false)} color="error">
        Remove Cash
      </Button>
    </div>
  );

  return (
    <>
      <Table
        ActionComp={() => <></>}
        HeaderComp={HeaderComp}
        tblHead={[
          { id: "txnDate", label: "Date & Note" },
          { id: "user", label: "User" },
          { id: "reason", label: "Reasons" },
          { id: "amount", label: "Amount" },
        ]}
        tblData={txns.map((txn) => {
          var isCashIn = txn.txnType === 1 || txn.txnType === 3 ? true : false;
          var txnTypeDlt = TxnTypes.find((j) => j.id === txn.txnType);
          var txnName = txnTypeDlt && txnTypeDlt.label;

          return {
            ...txn,
            txnDate: (
              <div className="grid font-medium">
                <span className="text-[14px]">{formatDate(txn.txnDate)}</span>
                {txn.note && (
                  <div className="max-w-[300px] text-[13px] whitespace-pre-line border-t">
                    <span>{txn.note}</span>
                  </div>
                )}
              </div>
            ),
            user: txn.user && (
              <div className="d-grid">
                <span>{txn?.user?.fullName}</span>
                <a className="fs-12 link" href={`mailto:${txn.user.email}`}>
                  {txn?.user?.email}
                </a>
              </div>
            ),
            reason: (
              <div>
                <Chip
                  label={txnName}
                  color={
                    txn.txnType === 5
                      ? "primaryXS"
                      : isCashIn
                      ? "success"
                      : "error"
                  }
                  className={`text-[10px] !h-[25px] shadow-xl font-medium tracking-wider uppercase`}
                />
              </div>
            ),
            amount: (
              <span
                className={`text-[18px] font-medium ${
                  txn.txnType === 5
                    ? "primary-color"
                    : isCashIn
                    ? "text-green-500"
                    : "text-red-500"
                }`}
              >
                {formatPrice(txn.amount)}
              </span>
            ),
          };
        })}
      />

      {/* Add Follow Up */}
      {showForm && (
        <Dialog show={showForm} onClose={false} maxWidth="xs">
          <CashAddAndRemove
            {...{
              setShowForm: setShowForm,
              isCashInForm: cashInForm,
              setAlert,
              setTxns,
              activeReg,
              authUser,
            }}
          />
        </Dialog>
      )}

      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </>
  );
};

export default CashMgmts;
